import type { FC, ReactNode } from "react";

interface Props {
  children: ReactNode;
}

const InformationLayout: FC<Props> = (props) => {
  const { children } = props;

  return <div className="col-lg-12 col-md-12 mb-4">{children}</div>;
};

export default InformationLayout;
